module.exports = __webpack_public_path__ + "img/d711b67.jpg";